export default __webpack_public_path__ + "static/Training-9ad73540df8dbaa8d0c782cdab0dc804.jpeg";